import React from 'react';

import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import Strip from '../../common/Strip';
import TextHeader from '../../common/TextHeader';
import Styles from './ControlFx.module.scss';

const LinkRenderer = (props: any) => (
  <a className={Styles.link} href={props.href} target="_blank" rel="noreferrer">
    {props.children}
  </a>
);

const ControlFx = () => {
  const { t } = useTranslation('clients');
  const {
    controlFx: {
      title,
      outsourcedExecution,
      downstreamReporting,
      autoSettlement,
      transactionAnalysis,
      tradeInstruction,
    },
  } = t('corporate-treasurers', {
    returnObjects: true,
  }) as any;

  return (
    <Strip variant="grey" style={{ paddingTop: 40, paddingBottom: 50 }}>
      <TextHeader
        level={2}
        data={{ title: <span style={{ maxWidth: 390, display: 'inline-block' }}>{title}</span> }}
      />
      <div className={Styles.wrapper}>
        <Image
          width={448}
          src="/images/client/wheelM.png"
          alt={title}
          className={Styles.wheelImg}
          height={415}
        />
        <div className={Styles.outsourcedExecution}>
          <h4 className={Styles.title}>
            <ReactMarkdown rehypePlugins={[rehypeRaw]} components={{ a: LinkRenderer }}>
              {outsourcedExecution.title}
            </ReactMarkdown>
          </h4>
          <p>{outsourcedExecution.description}</p>
        </div>
        <div className={Styles.downstreamReporting}>
          <h4 className={Styles.title}>{downstreamReporting.title}</h4>
          <p>{downstreamReporting.description}</p>
        </div>
        <div className={Styles.autoSettlement}>
          <h4 className={Styles.title}>{autoSettlement.title}</h4>
          <p>{autoSettlement.description}</p>
        </div>

        <div className={Styles.transactionAnalysis}>
          <h4 className={Styles.title}>
            <ReactMarkdown rehypePlugins={[rehypeRaw]} components={{ a: LinkRenderer }}>
              {transactionAnalysis.title}
            </ReactMarkdown>
          </h4>
          <p>{transactionAnalysis.description}</p>
        </div>
        <div className={Styles.tradeInstruction}>
          <h4 className={Styles.title}>
            <ReactMarkdown rehypePlugins={[rehypeRaw]} components={{ a: LinkRenderer }}>
              {tradeInstruction.title}
            </ReactMarkdown>
          </h4>
          <p>{tradeInstruction.description}</p>
        </div>
      </div>
    </Strip>
  );
};

export default ControlFx;
